import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { default as wallboardViewName, WallboardView } from './view/wallboard-view.component.ajs';
import { WallboardRouter } from './wallboard-router';
import { default as wallboardServiceName, WallboardService } from './wallboard.service';

export default module('contact.wallboard', ['gridster'])
  .component(wallboardViewName, new WallboardView())
  .service(wallboardServiceName, WallboardService)
  .factory('wallboardRouter', downgradeInjectable(WallboardRouter)).name;
